export enum AuthorityReport {
  REPORT_PRODUCTIVE_VIEW = '5.12',
  REPORT_DRE_VIEW = '5.13',
  REPORT_COMMISSION_VIEW = '5.11',
  REPORT_INVENTORY_VIEW = '5.10',
  REPORT_PRINT_WITH_VALUES = '5.9',
  REPORT_VIEW_MANAGERIAL_REPORTS = '5.8',
  REPORT_VIEW_BALANCE = '5.7',
  REPORT_VIEW_INVOICE_REPORTS = '5.6',
  REPORT_VIEW_DIRECT_SALES_REPORTS = '5.5',
  REPORT_VIEW_ACCOUNTS_RECEIVABLE_REPORTS = '5.4',
  REPORT_VIEW_ACCOUNTS_PAYABLE_REPORTS = '5.3',
  REPORT_VIEW_PURCHASE_REPORTS = '5.2',
  REPORT_VIEW_MOVIMENTATION_WORKORDER_REPORTS = '5.1',
  REPORT_REPORTS = '5.',
  REPORT_BANK_SLIP_VIEW = '5.14',
  REPORT_VIEW_ABC_CURVE = '5.15',
}
